<template>
  <v-tooltip bottom max-width="360">
    <template v-slot:activator="{ on, attrs }">
      <v-icon small color="primary" v-bind="attrs" v-on="on">mdi-help-circle-outline</v-icon>
    </template>
    <span>{{ text }}</span>
  </v-tooltip>
</template>

<script>
export default {
  name: "EHelpTooltip",
  props: {
    text: {
      type: String,
      default: "",
    },
  },
};
</script>
